import React from 'react';
import {HorizontalCardProps} from './types';
import styled from 'styled-components';
import {COLORS} from '../../styles';
import {ImageWithFallbacks} from "../../Image";

export const HorizontalCardIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 64px;
  height: 80px;

  color: ${COLORS.black};

  .disabled & {
    color: ${COLORS.neutral_500};
  }
`;


export const HorizontalCardImageContainer = styled.div`
  height: 100%;
  overflow: hidden;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  width: 120px;

  img {
    mix-blend-mode: multiply;
    object-fit: cover;
    width: 100%;
    height: 100%;

  }

  .disabled & {
    img {
      filter: grayscale(100%);
    }
  }

`;

type Props = Pick<HorizontalCardProps, 'image' | 'icon'>;

export const HorizontalCardThumbnail: React.FunctionComponent<Props> = ({
                                                                          image,
                                                                          icon
                                                                        }) => {

  return (
    <>
      {
        icon &&
          <HorizontalCardIconContainer>
            {React.cloneElement(icon, {width: 48, height: 48})}
          </HorizontalCardIconContainer>
      }
      {
        image &&
          <HorizontalCardImageContainer>
              <ImageWithFallbacks fallbacks={image.fallbackSrc ?? ''} src={image.src} alt={image.alt}
                                  loader={image.loader ?? false} width={image.width} height={image.height}/>
          </HorizontalCardImageContainer>
      }
    </>
  )
};
